import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
    launchAiService,
    publishService,
    saveServiceDetails,
    setCreateNewAiService,
} from "../../../Services/Redux/actionCreators/aiServiceDetailsActions";
import { useNavigateTo } from "../../../GlobalRouter/hook/NavigateTo";
import { Debug } from "../../../data/configuration";
import { storageProviders } from "../../../Utils/storageTypes";

const useSubmit = () => {
    const dispatch = useDispatch();
    const navigateTo = useNavigateTo();
    const { serviceDetails, organization } = useSelector(
        (state) => ({
            serviceDetails: state.aiServiceDetails,
            organization: state.organization,
        }),
        shallowEqual
    );

    const submitServiceUpdate = async () => {
        try {
            if (!Debug.skipSubmitService) {
                await dispatch(saveServiceDetails(organization.uuid, serviceDetails));
                const launchStorageProvider = serviceDetails?.storageProvider
                    ? serviceDetails.storageProvider
                    : storageProviders.IPFS;
                const { publish_to_blockchain, service_metadata_uri } = await dispatch(
                    launchAiService(
                        organization.uuid,
                        serviceDetails.uuid,
                        launchStorageProvider,
                        serviceDetails.lighthouseToken
                    )
                );
                if (publish_to_blockchain) {
                    await dispatch(
                        publishService(organization, serviceDetails, service_metadata_uri)
                    );
                }
            }
            dispatch(setCreateNewAiService(true));
            navigateTo.services({ orgUuid: organization.uuid, afterServiceLaunch: true });
        } catch (error) {
            throw error;
        }
    };

    return { submitServiceUpdate };
};

export default useSubmit;
